import { render } from "./ModuleCard.vue?vue&type=template&id=dada9894&scoped=true"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"

import "./ModuleCard.vue?vue&type=style&index=0&id=dada9894&lang=scss&scoped=true"
import "./ModuleCard.vue?vue&type=style&index=1&id=dada9894&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dada9894"]])

export default __exports__